import "./Header.css";

export default function Header() {
  return (
    <header className="header-bar">
      <span className="header-title">CTViz | CBCT Laminography Geometry</span>
    </header>
  );
}
